<template>
    <div style="padding: 15px 15px">
        <el-form :inline="true" class="demo-form-inline" :maxHeight="10" style="padding-top: 10px">
        <el-form-item :label="$t('钱包地址')">
          <el-input v-model="address" :placeholder="$t('钱包地址')" style="width: 450px"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="fetchDataV1">{{
            $t("查询")
            }}</el-button>
            <el-button type="primary" @click="openRemarksDialog">{{
          $t("Wallet remarks")
          }}</el-button>
          <a :href="gmgnaiWaller" target="_blank"><el-button type="primary">详情</el-button></a>
        </el-form-item>
      </el-form>
  

      <div class="tables-container table-bottom">
         <el-table
          :data="genDanResponseList"
          v-loading="loading"
          :row-style="{ height: '0' }"
          :cell-style="{ padding: '5px' }"
          border
          class="table-left"
        >
          <!-- <el-table-column
            prop="address"
            :label="$t('钱包地址')"
          >
          </el-table-column> -->
  
          <el-table-column
            prop="ca"
            :label="$t('CA地址')"
          >
            <template slot-scope="scope">
                <a :href="`https://gmgn.ai/sol/token/${scope.row.ca}`" target="_blank" :class="'link-color'">
                    {{scope.row.ca}}
                </a>
                <el-button size="mini" round @click="copyValue(scope.row.ca)">复制</el-button>
            </template>
          </el-table-column>

          <el-table-column
            prop="isRay"
            :label="$t('阶段')"
          >
          </el-table-column>

          <el-table-column
            prop="lastBuyTime"
            :label="$t('时间')"
          >
          </el-table-column>
          
          <el-table-column
            prop="buyAmountTotal"
            :label="$t('尾巴买入金额(sol)')"
          >
          </el-table-column>

          <el-table-column
            prop="sellAmountTotal"
            :label="$t('尾巴卖出金额(sol)')"
          >
          </el-table-column>        


           <el-table-column
            prop="buyNum"
            :label="$t('尾巴买入次数')"
          >
          </el-table-column>
          <el-table-column
            prop="sellNum"
            :label="$t('尾巴卖出次数')"
          >
          </el-table-column>
          <el-table-column
            prop="netPurchasesTotal"
            :label="$t('净买入(sol)')"
          >
          </el-table-column>
          <el-table-column
            prop="hole"
            :label="$t('单币持有时间（秒）')"
          >
          </el-table-column>
  
        </el-table>
      </div>



      <el-form :inline="true" class="demo-form-inline" :maxHeight="10" style="padding-top: 10px">
        <el-form-item :label="$t('钱包地址')">
          <el-input v-model="address" :placeholder="$t('钱包地址')" style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item :label="$t('合约')">
          <el-input v-model="pumpca" :placeholder="$t('合约地址')" style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="fetchData">{{
            $t("查询")
            }}</el-button>
            <a :href="gmgnai" target="_blank"><el-button type="primary">gmgn</el-button></a>
        </el-form-item>
      </el-form>

      <div style="margin-bottom: 10px">
        <a :href="`https://gmgn.ai/sol/address/${devWaller}`" target="_blank" :class="'link-color'">
          DEV地址：{{ devWaller }}
        </a>
      </div>
  

      <div class="tables-container table-bottom">
         <el-table
          :data="genDanLogResponseList"
          v-loading="loading"
          :row-style="{ height: '0' }"
          :cell-style="{ padding: '5px' }"
          border
          class="table-left"
        >
          <el-table-column
            prop="fromAddress"
            :label="$t('钱包地址')"
          >
          <template slot-scope="scope">
            <span  :class="{ 'text-red': isConditionMet(scope.row.fromAddress) }">
                {{ scope.row.fromAddress}}
              </span>
          </template>
          </el-table-column>
  
          <el-table-column
            prop="type"
            :label="$t('类型')"
          >
          </el-table-column>
          
          <el-table-column
            prop="format"
            :label="$t('时间')"
          >
          </el-table-column>

          <el-table-column
            prop="num"
            :label="$t('金额(sol)')"
          >
        </el-table-column>    
        
        <el-table-column
            prop="remarks"
            :label="$t('备注')"
          >
        </el-table-column>

          <el-table-column
            prop="hash"
            :label="$t('hash')"
          >
          <template slot-scope="scope">
            <a :href="`https://solscan.io/tx/${scope.row.hash}`" target="_blank" :class="'link-color'">
              {{'HASH'}}
            </a>
          </template>
          </el-table-column>
        </el-table>
      </div>




      <el-form :inline="true" class="demo-form-inline" :maxHeight="10" style="padding-top: 10px">
        <el-form-item :label="$t('钱包地址')">
          <el-input v-model="address" :placeholder="$t('钱包地址')" style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="queryTrumpet">{{
            $t("查询")
            }}</el-button>
            <a :href="gmgnai" target="_blank"><el-button type="primary">gmgn</el-button></a>
        </el-form-item>
      </el-form>

      <div class="tables-container table-bottom">
         <el-table
          :data="trumpetList"
          v-loading="loading"
          :row-style="{ height: '0' }"
          :cell-style="{ padding: '5px' }"
          border
          class="table-left"
        >
          <el-table-column
            prop="fromAddress"
            :label="$t('钱包地址')"
          >
          <template slot-scope="scope">
            <span  :class="{ 'text-red': isConditionMet(scope.row.fromAddress) }">
                {{ scope.row.fromAddress}}
              </span>
          </template>
          </el-table-column>
  
          <el-table-column
            prop="num"
            :label="$t('出现次数')"
          >
          </el-table-column>
       

        </el-table>
      </div>


      <el-dialog :visible.sync="remarkDialogShow" width="1000px" center close-on-click-modal v-if="remarkDialogShow">
      <el-table :data="remarkDialogData" border>
        <el-table-column :label="$t('Address')">
          <template slot-scope="scope">
            <el-input v-model="scope.row.key" size="small"></el-input>
          </template>
        </el-table-column>
        <el-table-column :label="$t('Remark')">
          <template slot-scope="scope">
            <el-input v-model="scope.row.value" size="small"></el-input>
          </template>
        </el-table-column>
        <el-table-column :label="$t('Operation')">
          <template slot-scope="scope">
            <el-button type="text" style="color: red" @click="delDialogRemark(scope.row)">{{ $t("Delete") }}</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div style="margin-top: 20px" class="box box-center">
        <el-button type="text" @click="addDialogRemark()">{{ $t("New line") }}</el-button>
      </div>
      <div class="remarkSave">
        <el-button type="primary" @click="saveDialogRemark()">{{ $t("Save") }}</el-button>
      </div>
    </el-dialog>

       <!--  <div class="block">
          <el-cascader
            v-model="value"
            :options="options"
            @change="handleChange">
          </el-cascader>
       </div> -->

    </div>

    
  </template>
  
  <script>
  import Plate from "./Plate";
  export default {
    name: "mouse",
    components: { Plate },
    data() {
      return {
        number: "*",
        token: "",
        address: "",
        pumpca: "",
        caInfoMap: "",
        mouse: [],
        wallet: [],
        topMapList: [],
        wallerInfoList: [],
        goldenDogs: [],
        insideDishs: [],
        genDanLogResponseList: [],
        genDanResponseList: [],
        trumpetList: [],
        loading: false,
        pumpurl: "",
        gmgnai: "",
        gmgnaiWaller: "",
        bubble: "",
        lang: this.$i18n.locale,
        themeType: "dark",
        dialogVisible: false,
        width: window.innerWidth / 3,
        data: [],
        remarkDialogShow: false,
        devWaller: "",
        remarkDialogData: [],
        retrievedMap: new Map(),
        value: [],
        options: [{
          value: 'zhinan',
          label: 'HxxVw4JQYgqxUGRruAzTj4Nrisc2e3qr9azVn7fVtnSo',
          children: [{
            value: 'shejiyuanze',
            label: '设计原则',
            children: [{
              value: 'yizhi',
              label: '一致'
            }, {
              value: 'fankui',
              label: '反馈'
            }, {
              value: 'xiaolv',
              label: '效率'
            }, {
              value: 'kekong',
              label: '可控'
            }]
          }, {
            value: 'daohang',
            label: '导航',
            children: [{
              value: 'cexiangdaohang',
              label: '侧向导航'
            }, {
              value: 'dingbudaohang',
              label: '顶部导航'
            }]
          }]
        }]
      };
  
    },
    mounted() {
      this.loadData();
      document.getElementById("app").setAttribute("class", themeClass);
    },
    methods: {
      fetchData() {
        localStorage.setItem("address", this.address);
        localStorage.setItem("pumpca", this.pumpca);
        this.loading = true;
        this.gmgnai = "https://gmgn.ai/sol/token/"+this.pumpca+"?tab=activity&maker="+this.address;
        
        this.$axios
          .get("/api/genDanLog/" + this.address.trim()+"/"+this.pumpca.trim())
          .then((successResponse) => {
            this.genDanLogResponseList = successResponse.data.map(item => {
            return {
              ...item,
              remarks: this.retrievedMap.get(item.fromAddress),
            };
          });
            this.loading = false;
          })
          .catch((failResponse) => {
            this.$message({
              message: failResponse.response.data,
              type: "error",
              duration: 2000,
            });
            this.loading = false;
            // 处理失败响应
          });

          this.$axios
          .get("/api/getCaDev/"+this.pumpca.trim())
          .then((successResponse) => {
            this.devWaller = successResponse.data.createBy;
          })
          .catch((failResponse) => {
            this.$message({
              message: failResponse.response.data,
              type: "error",
              duration: 2000,
            });
            this.loading = false;
            // 处理失败响应
          });
      },
      fetchDataV1() {
        this.loading = true;
        this.gmgnaiWaller = "https://gmgn.ai/sol/address/"+this.address;
        this.$axios
          .get("/api/genDan/" + this.address.trim())
          .then((successResponse) => {
            this.genDanResponseList = successResponse.data;
            this.loading = false;
          })
          .catch((failResponse) => {
            this.$message({
              message: failResponse.response.data,
              type: "error",
              duration: 2000,
            });
            this.loading = false;
            // 处理失败响应
          });
      },
      queryTrumpet() {
        this.$axios
          .get("/api/queryTrumpet/" + this.address.trim())
          .then((successResponse) => {
            this.trumpetList = successResponse.data;
          })
          .catch((failResponse) => {
            this.$message({
              message: failResponse.response.data,
              type: "error",
              duration: 2000,
            });
            this.loading = false;
            // 处理失败响应
          });
      },
      loadData() {
      this.address = localStorage.getItem("address");
      this.pumpca = localStorage.getItem("pumpca");
    },
    httpGetRemarks() {
      this.$axios
        .get("/api/getGendanRemarks")
        .then((successResponse) => {
          this.remarkDialogData = successResponse.data;
          let map = new Map();
          for (const item of this.remarkDialogData) {
            map.set(item.key, item.value);
          }
          this.retrievedMap = map;
        })
        .catch((failResponse) => {
          // 处理失败响应
        });
    },
    // 打开弹窗
    openRemarksDialog  () {
      this.httpGetRemarks();
      this.remarkDialogShow = true;
    },
    // 添加
    addDialogRemark() {
      this.remarkDialogData.push({
        id: this.remarkDialogData.length + 1,
        key: "",
        value: "",
      });
    },
    // 删除
    delDialogRemark(item) {
      this.remarkDialogData.splice(this.remarkDialogData.findIndex(res => { return res.id == item.id }), 1);
    },
    // 保存
    saveDialogRemark() {
      let map = new Map();
      for (const item of this.remarkDialogData) {
        map.set(item.key, item.value);
      }
      this.retrievedMap = map;
      try {
        this.$axios.post('/api/savaGendanRemarks', {
          token: this.token,
          remarks: JSON.stringify(this.remarkDialogData)
        });
      } catch (error) {
      }
      this.$message.success(this.$t("Save successful"));
    },
      getRowClassName({ row, index }) {
        if (row.isMouse === 1) {
          return "row-color-2";
        }
      },
      copyValue(symbol) {
        this.$message({
          message: this.$t("Copy successful"),
          type: "success",
          duration: 500,
        });
        navigator.clipboard
          .writeText(symbol)
          .then(function () { })
          .catch(function (err) { });
      },
      parsedTime(e) {
        if(e != null && e != 'null' && e != ''){
          return new Date(e * 1000).toLocaleString();
        }else{
          return ''
        }
      },
      isConditionMet(fromAddress){
        return this.address === fromAddress
      },
    },
  };
  </script>
  
  <style scoped>
  .tables-container {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
  
  .link-color {
    color: #409eff;
  }
  
  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
    margin-left: 30px;
  }
  
  .el-icon-arrow-down {
    font-size: 12px;
  }
  
  .el-icon-sunny {
    font-size: 25px;
    margin-left: 20px;
  }
  
  .el-icon-moon {
    font-size: 25px;
    margin-left: 20px;
  }
  
  .el-icon-s-promotion {
    margin-left: 25px;
    font-size: 30px;
  }
  
  .box-three {
    margin: 30px 0;
  }
  
  .table-left {
    margin-right: 15px;
  }
  
  .table-bottom {
    margin-bottom: 30px;
  }
  .text-red{
    color:red;
  }
  .remarkSave {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 30px;
  }
  
  .box {
    display: flex;
  }
  
  .box-column-center {
    justify-content: center;
  }
  
  .box-center {
    justify-content: center;
    align-items: center;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/Gendan.vue